/**
 * Single currency formatter for every landing pricing surface. Both
 * `usePricingCatalog` and the pricing calculator render amounts through
 * this helper so formatting policy (symbol placement, fraction digits,
 * grouping) cannot drift between the hook-derived strings and the
 * calculator's own math (#1013 review feedback — the two previously had
 * near-identical inline copies with different signatures).
 *
 * `fractionDigits` is pinned as both the minimum and the maximum so a
 * given surface always shows a stable width: 0 for headline prices
 * ("R$ 50"), 2 for body prices ("R$ 50,00"), 3 for the per-check rate
 * ("R$ 0,050").
 */
export function formatCurrency(
  value: number,
  locale: string,
  currency: string,
  fractionDigits = 2,
): string {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(value);
}
